export default "https://api-gerenciador-dev.launchpad.com.br";
